<template>
    <div class="wrap"
        @mousedown="willRotate = false"
        @mouseup="willRotate = true"
        @touchend.passive="willRotate = true"
        @touchstart.passive="willRotate = false">
        <VuePannellum
        :src="getCurrPanelumImg"
        :preview="loadingImg"
        class="int360"></VuePannellum>
        <svg v-show="willRotate" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30C60 46.5685 46.5685 60 30 60C13.4315 60 0 46.5685 0 30Z" fill="white"/>
            <path d="M30 31.3323C29.51 31.3323 18 31.3671 18 34.396C18 36.7737 25.0188 37.3033 28.0121 37.4209L27.028 38.3997C26.7685 38.6569 26.7674 39.0762 27.0252 39.3358C27.2831 39.5953 27.7023 39.5976 27.9616 39.3392L29.8473 37.4647C30.1066 37.2069 30.1295 36.7682 29.8943 36.4883C29.4178 35.9221 28.6474 35.0129 28.1687 34.4475C27.9323 34.1693 27.5144 34.134 27.2355 34.3715C26.9571 34.6083 26.9226 35.0258 27.1595 35.3046L27.8253 36.0893C23.6035 35.9176 20.9693 35.2831 19.8813 34.7674C19.5508 34.6109 19.5474 34.1768 19.8779 34.0191C21.189 33.3971 24.6954 32.656 30.0005 32.656C35.3057 32.656 38.812 33.3973 40.1226 34.0191C40.4531 34.1762 40.4497 34.6109 40.1186 34.7674C38.9831 35.3049 36.1682 35.9741 31.6174 36.1103C31.2522 36.1214 30.9607 36.4226 30.9674 36.7886C30.974 37.154 31.2754 37.4453 31.6412 37.4334C34.3953 37.3437 42 36.8708 42 34.3958C41.9994 31.3674 30.4902 31.3323 30 31.3323Z" fill="black"/>
            <path d="M19.815 30.2382V28.9317H19.9624C20.6648 29.3337 21.3225 29.5341 21.9359 29.5341C22.4205 29.5341 22.7993 29.4339 23.072 29.2329C23.3449 29.0321 23.4814 28.7384 23.4814 28.352C23.4814 28.0454 23.3749 27.8084 23.1618 27.6414C22.9485 27.4745 22.5078 27.3907 21.8392 27.3907H21.4344V26.3462H21.8162C22.8467 26.3462 23.362 26.0319 23.362 25.4031C23.362 25.1393 23.2514 24.9391 23.0306 24.8028C22.8098 24.6662 22.4955 24.598 22.0875 24.598C21.5384 24.598 20.8945 24.7943 20.1554 25.1868H20.0174V23.8942C20.7965 23.6029 21.5463 23.4569 22.2668 23.4569C23.1193 23.4569 23.7642 23.6134 24.201 23.9263C24.6379 24.2392 24.8566 24.6544 24.8566 25.1729C24.8566 25.5593 24.7354 25.8976 24.4932 26.1873C24.2508 26.4773 23.9274 26.6712 23.5225 26.7694V26.8337C23.9856 26.9167 24.3521 27.0967 24.6221 27.3744C24.892 27.652 25.0269 28.0101 25.0269 28.4487C25.0269 29.1233 24.7694 29.6633 24.2541 30.0681C23.7388 30.4729 23.0413 30.6753 22.1608 30.6753C21.3083 30.6749 20.5262 30.5291 19.815 30.2382Z" fill="black"/>
            <path d="M30.9708 23.5723V24.7589H30.8372C30.5462 24.6179 30.1943 24.5474 29.7836 24.5474C28.5296 24.5474 27.8303 25.2037 27.6861 26.5164C28.2933 26.1544 28.8423 25.9735 29.3328 25.9735C30.0111 25.9735 30.5573 26.1682 30.973 26.5577C31.3883 26.9473 31.5963 27.4933 31.5963 28.1956C31.5963 28.9255 31.3473 29.5211 30.8487 29.9825C30.3502 30.4444 29.7101 30.6751 28.928 30.6751C28.0295 30.6751 27.3417 30.3982 26.8648 29.8443C26.388 29.2909 26.1493 28.4914 26.1493 27.4456C26.1493 26.1607 26.4644 25.1746 27.0948 24.4874C27.7252 23.8006 28.6395 23.457 29.8389 23.457C30.2621 23.4574 30.6395 23.4956 30.9708 23.5723ZM27.6815 27.2664L27.6768 27.4549C27.6736 27.5559 27.6722 27.6375 27.6722 27.6987C27.6722 28.9931 28.0925 29.6399 28.9328 29.6399C29.27 29.6399 29.5423 29.5207 29.7491 29.2811C29.9565 29.042 30.0597 28.7061 30.0597 28.2738C30.0597 27.4303 29.6192 27.0087 28.7395 27.0087C28.3963 27.0089 28.0434 27.0947 27.6815 27.2664Z" fill="black"/>
            <path d="M35.1799 30.6752C34.2384 30.6752 33.5476 30.389 33.1076 29.8175C32.6671 29.2451 32.4475 28.3274 32.4475 27.0641C32.4475 25.8128 32.6681 24.8989 33.1099 24.3224C33.5517 23.7457 34.2413 23.4575 35.1798 23.4575C36.1184 23.4575 36.8083 23.7451 37.2502 24.32C37.6916 24.8949 37.9126 25.8083 37.9126 27.0595C37.9126 28.3323 37.6934 29.2531 37.2547 29.822C36.816 30.391 36.1246 30.6752 35.1799 30.6752ZM35.1799 24.529C34.7503 24.529 34.4432 24.7306 34.2578 25.134C34.072 25.5372 33.9795 26.1823 33.9795 27.0683C33.9795 27.9516 34.0744 28.5954 34.2645 29.0004C34.4548 29.4052 34.76 29.6076 35.1801 29.6076C35.6003 29.6076 35.9055 29.4024 36.0956 28.9915C36.286 28.5804 36.381 27.9365 36.381 27.0592C36.381 26.1759 36.2882 25.5335 36.1028 25.1316C35.9166 24.73 35.6092 24.529 35.1799 24.529Z" fill="black"/>
            <path d="M40.8273 23.4572C40.8273 24.2618 40.1749 24.9142 39.3701 24.9142C38.5654 24.9142 37.9131 24.2618 37.9131 23.4572C37.9131 22.6523 38.5654 22 39.3701 22C40.1749 22 40.8273 22.6523 40.8273 23.4572Z" fill="black"/>
        </svg>
    </div>
</template>
<script>
    import VuePannellum from 'vue-pannellum'
    import { mapGetters, mapState } from 'vuex'

    export default {
        name: 'Interior360',
        components:{ VuePannellum, },
        props: {
            img360: { type: String},
        },
        data(){return{
            loadingImg: require('@/assets/img/hyuDefPhoto.webp'),
            willRotate: true,
        }},
        inject: ['page'],
        computed: {
            ...mapState(['resumeData']),
            ...mapGetters({
                getPanoramData: 'panoram360/getPanoramaicImgByVersion',
            }),
            getCurrPanelumImg(){
                if(this.page == 'Resume'){
                    let arr = this.getPanoramData(this.resumeData.modelid, this.resumeData.versionID)
                    let res = arr.find(el => el.idColor == this.resumeData.configSelected?.dsgInt.colorid)
                    return res?.panoramImg ? res?.panoramImg : this.loadingImg
                }
                return this.img360 ? this.img360 : this.loadingImg
            }
        },
        methods: {
            // runClick(){
            //     this.willRotate = !this.willRotate
            //     console.log('clied...', this.willRotate);
            // }
        }
    }
</script>
<style lang="scss">
    .pnlm-load-box{ display: none !important; background-position: center center;}
    .pnlm-container{
        background: unset;
        background-position: center center;
    }
</style>
<style lang="scss" scoped>
    .int360{
        min-height: 325px; //in case aspect ratio gets screwed
        aspect-ratio: 4/3;
    }

    .wrap{
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        // height: calc(100% - 4rem);
        height: 100%;
        z-index: 1;
        bottom: 2rem;

        & > svg{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }

    @include respond-to(large){
        .wrap{
            // top: 2rem;
            // height: calc(100% - 2rem);
        }
    }
</style>
